export const PRODUCT_OVERSCANNED = 'PRODUCT_OVERSCANNED'
export const SCANNED_CODE_NOT_IN_ORDER = 'SCANNED_CODE_NOT_IN_ORDER'
export const PICK_MODE = 'PICK_MODE'
export const PACK_MODE = 'PACK_MODE'
